import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { PartyPopper, X } from "lucide-react";

export default function VipLaunchBanner() {
  const [banners, setBanners] = useState([]);
  const [dismissed, setDismissed] = useState(() => {
    try { return JSON.parse(sessionStorage.getItem("mp_launch_banner_dismissed") || "[]"); } catch (e) { return []; }
  });

  useEffect(() => { api.get("/launch/banners").then((r) => setBanners(r.data.banners || [])).catch(() => {}); }, []);

  const src = (ph) => (ph ? (ph.startsWith("http") ? ph : `${process.env.REACT_APP_BACKEND_URL}${ph}`) : "");
  const key = (b) => `${b.pincode}|${b.area}`;
  const visible = banners.filter((b) => !dismissed.includes(key(b)));
  if (!visible.length) return null;

  const dismiss = (b) => {
    const d = [...dismissed, key(b)];
    setDismissed(d);
    try { sessionStorage.setItem("mp_launch_banner_dismissed", JSON.stringify(d)); } catch (e) { /* ignore */ }
  };

  return (
    <div className="max-w-7xl mx-auto px-5 sm:px-8 pt-4 space-y-2" data-testid="vip-launch-banner">
      {visible.map((b) => (
        <div key={key(b)} className="flex items-center gap-3 rounded-xl border border-[#d4af37]/40 text-white px-4 py-2.5 shadow" style={{ background: "linear-gradient(135deg,#0b3b2c,#1f7a5c)" }} data-testid={`vip-banner-${b.pincode}`}>
          {src(b.vip_photo) ? (
            <img src={src(b.vip_photo)} alt="" className="w-10 h-10 rounded-full object-cover border-2 border-[#d4af37] shrink-0" />
          ) : (
            <PartyPopper className="w-6 h-6 text-[#d4af37] shrink-0" />
          )}
          <div className="text-sm flex-1 min-w-0">
            <span className="font-semibold">My Property {b.area}</span> was launched{b.vip_name ? ` by ${b.vip_name}` : ""} 🎉
          </div>
          <button onClick={() => dismiss(b)} className="opacity-80 hover:opacity-100 shrink-0" data-testid="vip-banner-dismiss" aria-label="Dismiss">
            <X className="w-4 h-4" />
          </button>
        </div>
      ))}
    </div>
  );
}
